// extracted by mini-css-extract-plugin
export default {"menuItem":"_06Hul9A78TM5xwSBh-p7rA=="};